module.exports = __webpack_public_path__ + "img/1688-global.6082e3c7.png";